module.exports = __webpack_public_path__ + "static/media/verification_suite.41f3d7a5.svg";